var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopiedLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2444 2H15.2889C18.1117 2 20.4 4.32812 20.4 7.2C20.4 10.0719 18.1117 12.4 15.2889 12.4H13.2444M9.15556 2H7.11111C4.28833 2 2 4.32812 2 7.2C2 10.0719 4.28833 12.4 7.11111 12.4H9.15556M7.11111 7.2H15.2889",
    stroke: "#A71720",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopiedLink);
export default __webpack_public_path__ + "static/media/copied-link.b541fb63eabfbfc8980cb3e0f73fe8a6.svg";
export { ForwardRef as ReactComponent };